import { render } from "./PaidOrders.vue?vue&type=template&id=abb191f6&lang=pug"
import script from "./PaidOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./PaidOrders.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__